<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IN8tem/tc-custom/9780374713669.jpg?1730634344069" alt="This image is the cover for the book Black Water"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Black Water
      </h1>
      <p class="bookDescription body article font2">
        <b>The author of <i>Apple Tree Yard</i> delivers a “powerful, probing [international thriller] in the tradition of Graham Greene and John le Carré” (<i>Kirkus Reviews</i>, starred review).</b><br/><br/>John Harper is in hiding in a remote hut on a tropical island. As he lies awake at night, listening to the rain on the roof, he believes his life may be in danger. But he is less afraid of what is going to happen than of what he’s already done.<br/><br/>In a local town, he meets Rita, a woman with her own tragic history. They begin an affair, but can they offer each other redemption? Or do the ghosts of the past always catch up with us in the end?<br/><br/>Moving between Europe during the Cold War, Civil Rights–era California, and Indonesia during the massacres of 1965 and the subsequent military dictatorship, <i>Black Water </i>explores some of the darkest events of recent history through the story of one troubled man.<br/><br/><b>“This is a compelling and vivid psychological drama, with plenty of bite.” —Leyla Sanai, <i>The Guardian</i>, UK</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Louise Doughty
      </h2>
      
      <p class="authorDescription body article">LOUISE DOUGHTY is the author of several novels, including <I>Apple Tree Yard</I>, which was a top ten bestseller in the U.K. and Ireland and was translated into twenty-seven languages. It was long-listed for <I>The Guardian</I>’s Not the Booker prize and short-listed for a CWA Steel Dagger Award and a Specsavers National Book Award. Her sixth novel, <I>Whatever You Love</I>, was short-listed for the Costa Novel Award. She lives in London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6b253fec